// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "BOMTable"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      type: "button",
      button: {
        type: "text"
      },
      thStyle: { width: "60px" }
    },
    { key: "BOMId", label: "BOM编号", sortable: true, thStyle: { width: "140px" } },
    {
      key: "Name", label: "BOM名称", sortable: true,
      thStyle: { width: "12rem" },
      width: "12rem",
      type: "short"
    },
    { key: "ItemId", label: "物料编号", sortable: true, thStyle: { width: "120px" } },
    {
      key: 'NameAlias', label: '物料名称', sortable: true, thStyle: { width: "12rem" },
      width: "12rem",
      type: "short"
    },

    { key: "dataAreaId", label: "公司", thStyle: { width: "60px" } },
    { key: 'create_by_username', label: '创建人', sortable: true },
    { key: 'create_at', label: '创建时间', sortable: true, type: "date" },
    { key: 'is_approved', label: '审批', sortable: true, type: "boolean" },
    {
      key: 'approved_by_username', label: '审批人', sortable: true,
      formatter: (value, key, item) => {
        if (item.is_approved) {
          return item.approved_by_username
        } else {
          return ""
        }
      }
    },
  ],
  bom_detail: [
    { key: 'LineNum', label: '行号', sortable: true, type: "just_number", editable: true, require: true },
    { key: 'BOMType', label: '行类型', sortable: true, editable: true, require: true, thStyle: { width: "100px" } },
    // { key: 'BOMId', label: '物料清单编号', sortable: true },

    { key: 'ItemId', label: '物料编号', sortable: true },
    {
      key: 'NameAlias', label: '物料名称', sortable: true, thStyle: { width: "12rem" },
      width: "12rem",
      type: "short"
    },
    {
      key: 'ProductPartsType', label: '部件类别', type: "cascader", sortable: true, editable: true, thStyle: { width: "18rem" },
      width: "18rem",
    },
    { key: 'BOMQty', label: '数量', sortable: true, type: "just_number", editable: true, require: true },
    { key: 'BOMQtySerie', label: '按系列', sortable: true, type: "just_number", editable: true, require: true },
    { key: 'TEC_SpoilageType', label: '加放类型', sortable: true, editable: true, require: true, thStyle: { width: "130px" } },
    { key: 'TEC_IsPaper', label: '是否纸张', sortable: true, editable: true, require: true, thStyle: { width: "100px" } },
    { key: 'UseLength', label: '用料长(mm)', sortable: true, type: "just_number", editable: true },
    { key: 'UseWidth', label: '用料宽(mm)', sortable: true, type: "just_number", editable: true },
    { key: 'GramWeight', label: '克重(g)', sortable: true, type: "just_number", editable: true },
    { key: 'Calculation', label: '计算', sortable: true, editable: true, require: true, thStyle: { width: "100px" } },
    { key: 'BOMConsump', label: '消耗量', sortable: true, editable: true, thStyle: { width: "80px" } },
    { key: 'RoundUp', label: '进位', sortable: true, editable: true, thStyle: { width: "80px" } },
    { key: 'RoundUpQty', label: '倍数', sortable: true, type: "just_number", editable: true },
    { key: 'FromDate', label: '开始日期', sortable: true, type: "date", editable: true, require: true },
    { key: 'ToDate', label: '结束日期', sortable: true, type: "date", editable: true, require: true },
    { key: 'VendId', label: '供应商帐户', sortable: true, editable: true },
    { key: 'UnitId', label: '单位', sortable: true },
    { key: 'ScrapVar', label: '可变损耗', sortable: true, type: "just_number", editable: true },
    { key: 'ScrapConst', label: '固定损耗', sortable: true, type: "just_number", editable: true },
    { key: 'ProdFlushingPrincip', label: '耗用原则', sortable: true, editable: true },
    { key: 'PmfPlanGroupId', label: '计划组', sortable: true },
    { key: 'PmfPlanGroupPriority', label: '优先级', sortable: true, type: "just_number" },
    { key: 'TEC_CorrugatedPaperRate', label: '瓦楞纸系数', sortable: true, type: "number", editable: true },
    { key: 'Formula', label: '配方', sortable: true, editable: true },
    { key: 'TEC_Remark', label: '备注', sortable: true, type: "textarea", editable: true },
  ],
  bom_route_relation: [
    { key: 'LineNum', label: '行号', sortable: true },
    { key: 'BOMType', label: '行类型', sortable: true },
    // { key: 'BOMId', label: '物料清单编号', sortable: true },
    {
      key: 'ItemId', label: '物料编号', sortable: true
    },
    {
      key: 'NameAlias', label: '物料名称', sortable: true, thStyle: { width: "12rem" },
      width: "12rem",
      type: "short"
    },
    { key: 'OprNum', label: '工序', sortable: true, editable: true, thStyle: { width: "200px" } },
    { key: 'BOMQty', label: '数量', sortable: true },
    { key: 'TEC_SpoilageType', label: '加放类型', sortable: true },
    { key: 'TEC_IsPaper', label: '是否纸张', sortable: true },
    { key: 'BOMQtySerie', label: '按系列', sortable: true },
    { key: 'Calculation', label: '计算', sortable: true },
    { key: 'RoundUp', label: '进位', sortable: true },
    { key: 'RoundUpQty', label: '倍数', sortable: true },
    { key: 'FromDate', label: '开始日期', sortable: true },
    { key: 'ToDate', label: '结束日期', sortable: true },
    { key: 'VendId', label: '供应商帐户', sortable: true },
    { key: 'UnitId', label: '单位', sortable: true },
    { key: 'BOMConsump', label: '消耗量', sortable: true },
    { key: 'ScrapVar', label: '可变损耗', sortable: true },
    { key: 'ScrapConst', label: '固定损耗', sortable: true },
    { key: 'ProdFlushingPrincip', label: '耗用原则', sortable: true },
    { key: 'PmfPlanGroupId', label: '计划组', sortable: true },
    { key: 'PmfPlanGroupPriority', label: '优先级', sortable: true },
    { key: 'TEC_CorrugatedPaperRate', label: '瓦楞纸系数', sortable: true },
  ]
}

const dataForm = {}

///前端验证
const rules = {}
const methods = {
  ///get
  async getBomIdOptionsData(_params) {
    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields.default, "key")
      }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async getData(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper("get_bom_by_searchtext", {}, {})
    let result = await item_biz_data
      .execAction({
        params: _params,
        fields: _.map(fields.default, "key")
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async getBomItems(_params) {
    const biz_data = new biz_data_helper.base_entity_helper(
      "vInventBOM",
      create,
      descriptor
    )

    let f = _.map(fields.bom_detail, "key")
    f.push("id")
    f.push("OprNum")
    let result = await biz_data
      .selectAction({
        params: _params,
        fields: f
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async getBomTree(_params) {
    const biz_data = new biz_data_helper.base_entity_helper(
      "get_bom_tree",
      {},
      {}
    )
    let result = await biz_data
      .handlerScriptAction({
        params: _params,
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async getInventRouteList(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "get_invent_route",
      {},
      {}
    )
    let result = await item_biz_data
      .execAction({
        params: _params
      }).run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }

  },
  ///保存BOM主档
  async saveDataBom(params) {
    const biz_data_add = new biz_data_helper.base_entity_helper("insert_bom_table", {}, {})
    const del_bom_detail = new biz_data_helper.base_entity_helper("delete_bom_detail", {}, {})

    let _actions = []
    for (var k in params) {
      if (k == "add") {
        _actions.push(
          biz_data_add.execAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
      else if (k == "edit") {
        _actions.push(
          biz_data.updateAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
      else if (k == "delete") {
        _actions.push(
          biz_data.deleteAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
        _actions.push(
          del_bom_detail.execAction({
            params: _.map(params[k], (item) => { return { "BomId": item.BOMId } }),
            fields: []
          }).action({})
        )
      }
      else if (k == "approved") {
        _actions.push(
          biz_data.approveAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return result.data.BatchResult.Actions[0].Result.Data[0]
    } else {
      return null
    }
  },
  ///保存bom明细
  async saveDataBomItems(params) {
    const biz_data_opr = new biz_data_helper.base_entity_helper(
      "BOM",
      {},
      {}
    )
    let _actions = []
    for (var k in params) {
      if (k == "add") {
        _actions.push(
          biz_data_opr.insertAction({
            params: params[k],
            fields: _.map(fields.bom_detail, "key")
          }).action({})
        )
      }
      else if (k == "edit") {
        _actions.push(
          biz_data_opr.updateAction({
            params: params[k],
            fields: _.map(fields.bom_detail, "key")
          }).action({})
        )
      }
      else if (k == "delete") {
        _actions.push(
          biz_data_opr.removeAction({
            params: params[k],
            fields: _.map(fields.bom_detail, "key")
          }).action({})
        )
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  }
}
export { biz_data, dataForm, fields, methods, rules };

